import React from "react";

export const EventProperty = ({property, value, style}) => <div style={{
  fontSize:14,
  display:'flex',
  alignItems: 'center',
  gap:6,
  marginBottom:7
}}><div style={{width:86}}>{property}</div><b style={style}>{value}</b></div>
